import { Box, Flex } from '@sequencehq/core-components'
import { FC, ReactNode } from 'react'

type Props = {
  icons: ReactNode[]
}

export const WorkflowIconStack: FC<Props> = ({ icons }) => {
  return (
    <Flex position="relative" height="36px" flex="1">
      {icons.map((icon, index) => {
        return (
          <Box
            key={`icon-${index}`}
            position="absolute"
            zIndex={icons.length - index}
            left={`${index * 4}px`}
            _groupHover={{ left: `${index * 24}px` }}
            transition="left 250ms"
          >
            {icon}
          </Box>
        )
      })}
    </Flex>
  )
}
